webpackJsonp([5],{

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteHistory_vue__ = __webpack_require__(686);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87e3448c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteHistory_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87e3448c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_steem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(97);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VoteHistory',
  data: function data() {
    return {
      pagination: {
        index: 5
      },
      loading: true,
      headers: [{
        text: '사용자',
        align: 'center',
        sortable: true,
        value: 'voter'
      }, {
        text: '보팅금액',
        align: 'right',
        sortable: true,
        value: 'value'
      }, {
        text: '가중치',
        align: 'right',
        sortable: true,
        value: 'weight'
      }, {
        text: '큐레이션',
        align: 'right',
        sortable: true,
        value: 'curation'
      }, {
        text: '시간',
        align: 'center',
        sortable: true,
        value: 'time'
      }],
      active_votes: [],
      total_vote_weight: 0,
      pending_payout_value: 0,
      total_payout_value: 0,
      curator_payout_value: 0,
      title: '',
      author: '',
      author_reputation: 0,
      created: '',
      category: '',
      net_votes: 0,
      children: 0,
      cashout_time: ''
    };
  },

  filters: {
    formatTime: function formatTime(v) {
      var d = new Date(v);
      // return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)} ${('0' + d.getHours()).slice(-2)}:${('0' + d.getMinutes()).slice(-2)}`
      return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    payoutTime: function payoutTime() {
      var time = (new Date(this.cashout_time) - new Date()) / 1000;
      if (time > 86400) {
        return Math.round(time / 86400) + '일';
      } else if (time > 3600) {
        return Math.round(time / 3600) + '시간';
      } else if (time > 60) {
        return Math.round(time / 60) + '분';
      } else {
        return Math.round(time) + '초';
      }
    },
    payoutValue: function payoutValue() {
      return this.pending_payout_value + this.total_payout_value + this.curator_payout_value;
    },
    votes: function votes() {
      var _this = this;

      var totalRshares = 0;
      var totalWeight = 0;
      this.active_votes.forEach(function (e) {
        totalRshares += parseFloat(e.rshares); // 해당 포스트에 보팅된 총 리워드 계산
        totalWeight += parseFloat(e.weight); // 해당 포스트에 보팅된 총 가중치 계산
      });
      // console.log('total_vote_weight: ' + this.total_vote_weight, 'totalWeight: ' + totalWeight)
      return this.active_votes.map(function (e) {
        var value = void 0,
            curation = void 0;
        if (_this.pending_payout_value > 0) {
          // 페이아웃 이전
          value = e.rshares * (_this.global.rewardBalance / _this.global.recentClaims) * _this.global.price; // 업보팅한 금액
          // console.log(value)
          curation = '≈' + (e.weight / _this.total_vote_weight * _this.pending_payout_value * 0.25 / _this.global.price).toFixed(3) + ' SP'; // 받을 큐레이션 보상
        } else {
          // 페이아웃 이후
          var o = _this.total_payout_value ? _this.total_payout_value / (_this.total_payout_value + _this.curator_payout_value) : 0;
          value = o ? e.rshares / totalRshares * parseFloat(_this.total_payout_value / o) : 0; // 업보팅한 금액
          curation = (e.weight / totalWeight * _this.curator_payout_value).toFixed(3) + ' SBD'; // 받은 큐레이션 보상
          console.log(e.rshares, totalRshares, _this.total_payout_value, o);
        }
        return {
          voter: e.voter,
          reputation: __WEBPACK_IMPORTED_MODULE_1_steem___default.a.formatter.reputation(e.reputation),
          weight: e.percent / 100,
          value: value.toFixed(3),
          curation: curation,
          time: new Date(e.time + 'Z')
        };
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    global: function global(state) {
      return state.global;
    }
  })),
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    var author = this.$route.params.author; // path의 author 파람값
    var permlink = this.$route.params.permlink; // path의 permlink 파람값

    __WEBPACK_IMPORTED_MODULE_1_steem___default.a.api.getContentAsync(author, permlink).then(function (n) {
      console.log(n);
      _this2.title = n.title;
      _this2.total_vote_weight = n.total_vote_weight;
      _this2.pending_payout_value = parseFloat(n.pending_payout_value.split(' ')[0]); // 지급예정 보장(저자+큐레이션)
      _this2.total_payout_value = parseFloat(n.total_payout_value.split(' ')[0]); // 지급된 보상
      _this2.curator_payout_value = parseFloat(n.curator_payout_value.split(' ')[0]); // 지급된 큐레이션 보상
      _this2.active_votes = n.active_votes;
      _this2.author = n.author;
      _this2.author_reputation = n.author_reputation;
      _this2.created = n.created;
      _this2.category = n.category;
      _this2.net_votes = n.net_votes;
      _this2.children = n.children;
      _this2.cashout_time = n.cashout_time;
    }).catch(function (e) {
      return console.log(e);
    }).finally(function () {
      return _this2.loading = false;
    });
  },
  created: function created() {
    this.$store.dispatch('global/loadGlobalProperties');
  },
  deactivated: function deactivated() {
    this.$destroy();
  }
});

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(669)("395f79ce", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(668)(true);
// imports


// module
exports.push([module.i, "@media (max-width:540px){table.v-table td,table.v-table th{padding:0 5px!important}}", "", {"version":3,"sources":["C:/workspace/steemit-app/src/components/VoteHistory.vue"],"names":[],"mappings":"AACA,yBACA,kCACI,uBAA0B,CAC7B,CACA","file":"VoteHistory.vue","sourcesContent":["\n@media (max-width: 540px) {\ntable.v-table td, table.v-table th {\r\n    padding: 0 5px !important;\n}\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(!_vm.loading)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('v-layout',{attrs:{"justify-start":"","column":""}},[_c('v-flex',[_c('v-card',[_c('v-card-title',{staticClass:"title pb-0"},[_vm._v("\r\n              "+_vm._s(_vm.title)+"\r\n            ")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"pr-0",attrs:{"xs7":""}},[_c('v-list',{staticClass:"pt-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":'https://steemitimages.com/u/' + _vm.author + '/avatar/small',"alt":"avatar","onerror":"this.src='https://steemitimages.com/u/monawoo/avatar/small'"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.author)+" "),_c('span',{staticClass:"reputation"},[_vm._v("("+_vm._s(_vm._f("filterReputation")(_vm.author_reputation))+")")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("filterCreated")(_vm.created))+" · "+_vm._s(_vm.category))])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-4 pt-3",attrs:{"xs5":"","text-xs-right":""}},[_c('div',[_vm._v("좋아요 "+_vm._s(_vm.net_votes)+" · 댓글 "+_vm._s(_vm.children))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('strong',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("$"+_vm._s(_vm.payoutValue))]),_vm._v(" "),(_vm.pending_payout_value > 0)?_c('div',[_vm._v(" 예상 보상금액: $"+_vm._s(_vm.payoutValue)),_c('br'),_vm._v(" "),_vm._v("\r\n                  "+_vm._s(_vm.payoutTime)+" 후")]):_vm._e(),_vm._v(" "),(_vm.pending_payout_value === 0)?_c('div',[_vm._v("\r\n                     지급된 보상 $"+_vm._s(_vm.payoutValue)),_c('br'),_vm._v("\r\n                    - 저자 $"+_vm._s(_vm.total_payout_value)),_c('br'),_vm._v("\r\n                    - 큐레이터 $"+_vm._s(_vm.curator_payout_value)+"\r\n                  ")]):_vm._e()])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-subheader',{staticClass:"pl-0 subheading"},[_vm._v("보팅"),_c('small',[_vm._v("("+_vm._s(_vm.net_votes)+")")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.votes,"hide-actions":"","disable-initial-sort":"","loading":_vm.loading},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.voter)+" "),_c('span',{staticClass:"reputation"},[_vm._v("("+_vm._s(props.item.reputation)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("$"+_vm._s(props.item.value))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.weight)+"%")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.curation))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatTime")(props.item.time)))])]}}])})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.9b07bd4e68da6e344d8e.js